export default "__VITE_ASSET__BHt5opF7__"